/**
 * Product page helper (loaded on product pages only, see layout/theme.liquid).
 *
 * Hyper's sticky Add-to-cart bar (assets/sticky-atc-bar.js) shows whenever the main product form is not
 * 100% visible, so on shorter screens it covered the pack-size buttons and the real Add to cart button.
 * This only toggles html.ps-form-in-view while any part of the main form is on screen; assets/ps-pages.css
 * keeps the bar hidden in that state. Hyper's script and the form itself are untouched.
 */
(() => {
  const form = document.querySelector('.main-product-form');
  if (!form || !('IntersectionObserver' in window)) return;

  const root = document.documentElement;
  new IntersectionObserver(([entry]) => {
    root.classList.toggle('ps-form-in-view', entry.isIntersecting);
  }).observe(form);
})();
